import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const ForemanDashboardStatStyled = styled(Box).attrs({
  mb: { sm: '500' },
  px: { sm: '600' },
  pt: { sm: '500' },
  pb: { sm: '100' },
})`
  ${({ theme }) => css`
    & > :not(:last-child) {
      margin-right: ${theme.spacings[700]};
    }
  `}

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    & > :not(:last-child) {
      margin-right: ${({ theme }) => theme.spacings[500]};
    }
  }
`;

export const RodRequestListStyled = styled(Box).attrs({ flexGrow: { sm: 1 } })`
  max-height: 50vh;
  ${({ theme }) => css`
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 16%);
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[400]};
  `};
`;
